import React from 'react';
import Svgs from '../../resources/svgs';
import './info-tooltip.scss';

const InfoTooltip = (props) =>
  <div className="tool-tip" style={{display: 'flex'}}>
    <span
      className="tooltip tooltip-multiline modifier-class"
      aria-label={props.title}
    >
      {Svgs.description}
    </span>
  </div>
;

export default InfoTooltip;
